import dotenv from "dotenv" // As early as possible!
dotenv.config()

import App from "./app.vue"
import Router from "./router"

import Vue from "vue"
import "bootstrap/scss/bootstrap.scss"
import "@fortawesome/fontawesome-free/scss/fontawesome.scss"
import "@fortawesome/fontawesome-free/scss/regular.scss"
import "@fortawesome/fontawesome-free/scss/solid.scss"
import "./app.scss"
import "bootstrap/js/dist/modal.js"
import "bootstrap/js/dist/dropdown.js"
import "bootstrap/js/dist/carousel.js"
import "jquery-touchswipe/jquery.touchSwipe.min.js"

Vue.config.productionTip = false

new Vue({ router: Router, render: h => h(App) }).$mount("#app")
